import React from 'react';
import { Box } from '@mui/material';
// import FieldRow from './FieldRow'; // only used by the hidden Active field below
import LocalizedField from './LocalizedField';
import SectionBlock from './SectionBlock';

export default function RecognitionDetailPanel({ data, diffKeys = new Set(), side }) {
  if (!data) return null;

  return (
    <Box>
      <SectionBlock title="Content" />
      <LocalizedField
        label="Comment Text"
        fieldKey="localizedPairs"
        data={data.localizedPairs}
        diffKeys={diffKeys}
        side={side}
      />

      {/* Status/Active field — hidden for now
      <SectionBlock title="Status" />
      <FieldRow
        label="Active"
        value={data.isActive == null ? null : (data.isActive ? 'Yes' : 'No')}
        isChanged={diffKeys.has('isActive')}
        side={side}
      />
      */}
    </Box>
  );
}
